export const COURSE_CONFIG = {
  uk: {
    id: '69c3dfe5e8e5f68b0bec3ba3',
    slug: 'D19QTWs',
    token: 'NDVOfRR',
    locale: 'uk',
    bibleCode: 'cuv',
  },
  ru: {
    id: '69cebe2481e253ca9c8fc3f3',
    slug: 'dPX6',
    token: '',
    locale: 'ru',
    bibleCode: 'rst',
  },
  // Спільні для всіх локалей
  title: 'Основи Віри',
  accountId: '6329fda8e2afb4001c833a2e',
  introVideoId: 'lxGm59sVztY',
  author: 'Віктор Алєксєєнко',
} as const
